import { PendingRedemptionModal } from '@/components/PendingRedemptionModal';
import { usePendingRedemption } from '@/contexts/PendingRedemptionContext';
import { useAuth } from '@/contexts/AuthContext';

export const GlobalPendingRedemptionModal = () => {
  const { user } = useAuth();
  const { showPopup, dismissPopup, pendingCount } = usePendingRedemption();

  // Don't show if user is not authenticated or email not verified
  if (!user || user.email_verified !== true) return null;

  // Don't show if no pending redemptions
  if (pendingCount === 0) return null;

  return (
    <PendingRedemptionModal
      isOpen={showPopup}
      onClose={dismissPopup}
    />
  );
};
